/**
 * dateFnsLocale - map an i18n language code to a date-fns Locale.
 *
 * Used by relative-time helpers so date-fns output (e.g. "about 2 hours ago")
 * follows the active UI language instead of always rendering English.
 */

import type { Locale } from 'date-fns';
import { enUS, es, he, zhCN } from 'date-fns/locale';

const LOCALES: Record<string, Locale> = {
  en: enUS,
  es,
  he,
  zh: zhCN,
};

/**
 * Resolve a date-fns Locale from an i18n language code (e.g. 'en', 'es',
 * 'he', or a regioned variant like 'en-US'). Falls back to English.
 */
export function getDateFnsLocale(languageCode: string | undefined): Locale {
  if (!languageCode) return enUS;
  const base = languageCode.split('-')[0].toLowerCase();
  return LOCALES[base] ?? enUS;
}
